import { MainCard } from 'src/common';
import styled from 'styled-components';

export const Card = styled(MainCard)`
    @media screen and (max-height: 769px) {
        max-height: 90vh;
    }
`;
